.shimmer {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 50px;
}
.shimmer_box {
    width: 250px;
    margin: 0px 10px 20px 0px;
    background-color: white;
}
.shimmer_img{
    height: 160px;
}

.shimmer_detail {
    height: 30px;
}

.shimmer_box div {
    width: 100%;
    border-radius: 10px;
    background-color:#eff1f3;
    margin-bottom: 10px; 
    animation: shimmer 2s infinite;
    background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
    background-size: 1000px 100%;
}

@keyframes shimmer {
    0% {
        background-position: -1000px 0;
    }

    100% {
        background-position: 1000px 0;
    }
}